import { useEffect, useRef, useState } from "react";
import { DatePickerProps } from "react-datepicker";
import CalendarIcon from "@heroicons/react/24/outline/CalendarIcon";
import "react-datepicker/dist/react-datepicker.css";
import BaseDatePicker from "./forms/BaseDatePicker";

type Props = {
    onChange?: DatePickerProps["onChange"];
    classes?: { root?: string };
};

function DatePickerButton({ classes, onChange }: Props) {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [isOpen, setIsOpen] = useState(false);

    const buttonRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        if (!isOpen) return;
        const handleClickOutside = (event: MouseEvent) => {
            if (!(event.target instanceof HTMLElement)) return;
            if (
                !event.target.closest(".react-datepicker") &&
                buttonRef.current !== event.target
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [isOpen]);

    const handleChange = (date: any) => {
        setIsOpen(!isOpen);
        setStartDate(date);
        onChange?.(date);
    };
    const handleClick = (e: any) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };

    return (
        <div className={`${classes?.root} relative flex items-center`}>
            <button
                type="button"
                onClick={handleClick}
                ref={buttonRef}
                className="self-center hover:bg-gray-200 shrink-0 size-10 xl:size-10 rounded-full p-1.5 flex items-center justify-center"
            >
                <CalendarIcon className="h-5 w-5 text-blue-dark" />
            </button>
            {isOpen && (
                <BaseDatePicker startDate={startDate} onChange={handleChange} />
            )}
        </div>
    );
}

export default DatePickerButton;
